import { localeDefault } from "@app/config/constants";

export const formatShortDate = (dateString: string | null | undefined): string => {
  if (!dateString) {
    return "Never";
  }
  return new Date(dateString).toLocaleDateString(localeDefault, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  });
};
